// ignore-string-externalization
import React from "react";
export var LazyAccessRoutes = React.lazy(function() {
    return import(/* webpackChunkName: "access" */ "./AccessRoutes");
});
